import { render, staticRenderFns } from "./BalanceBarGraph.vue?vue&type=template&id=283187d4"
import script from "./BalanceBarGraph.vue?vue&type=script&lang=js"
export * from "./BalanceBarGraph.vue?vue&type=script&lang=js"
import style0 from "./BalanceBarGraph.vue?vue&type=style&index=0&id=283187d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports